import { useCallback, useState } from 'react';

import Tabs from '../../components/Tabs/Tabs';
import { getSlug } from '../../shared/helpers/getSlug';

import { Box } from './Box';
import { trackTabClick } from './tracking';

export const Card = ({
  content,
}: {
  content: {
    title: string;
    tabs: { label: string; content: React.ReactNode }[];
  };
}) => {
  const [tab, setTab] = useState(0);
  const handleTabChange = useCallback(
    (index: number) => {
      setTab(index);

      trackTabClick(getSlug(content.tabs[index].label));
    },
    [content.tabs]
  );

  return (
    <Box withBackground>
      <h2>{content.title}</h2>
      <Tabs
        onTabChange={handleTabChange}
        activeTab={tab}
        tabs={content.tabs.map((tab) => tab.label)}
      />
      {content.tabs[tab].content}
    </Box>
  );
};
